import lang from "@/views/modules/ApplicationEmails/language/en";
import breadcrumbs from "@/views/modules/ApplicationEmails/MenuList.vue";

export default {
    name: "app-email-details",
    
    components: {
        breadcrumbs,
    },
   data(){
       return {
        lang:[],
        record_id:null,
        record:null,
        emailstatus: {

        },
       }
   },
    mounted() {
        this.lang = lang;
        this.getEmailStatus();
    },
    methods: {
        getEmailStatus() {
            const self = this;
            self.record = self.$route.params.id;
            if (typeof (self.record) != 'undefined') {
                window.currentAction = 'list';
                axios.get('api/modules/applicatonemails/' + self.$route.params.id).then(function (response) {
                    self.emailstatus = response.data;
                    self.loading = false;
                }).catch(function () {
                    self.loading = false;
                });
            }
        },
    }
    
}